import { EtfPageProps } from '../utils/get-etf-props';

export const isEtfPageProps = (obj: any): obj is EtfPageProps => obj && 'asset' in obj && 'etfs' in obj;
